import { useState } from "react";
import AuthRightSide from "./Components/AuthRightSide";
import PreAuthLoginForm from "./Components/PreAuthLoginForm";
import SignUpForm from "./Components/SignUpForm";

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleAuthMode = () => {
    setIsLogin(!isLogin);
  };

  return (
    <div className="flex h-screen">
      {isLogin ? (
        <PreAuthLoginForm onToggle={toggleAuthMode} />
      ) : (
        <SignUpForm onToggle={toggleAuthMode} />
      )}
      <AuthRightSide />
    </div>
  );
};

export default AuthPage;
